import { useCallback } from 'react';
import { useWorkFlowCanvas } from '../../../../contexts/CampaignFlowProvider';
import { Canvas } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Canvas/Canvas';
import { NodeTypeKeys } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Canvas/utils/NodeTypeKeys';

export const useOnMessageDragEnd = () => {
  const { state, dispatch } = useWorkFlowCanvas();
  return useCallback(() => {
    const { nodes, edges } = Canvas.createFromState(state)
      .hideDropNodesFor(NodeTypeKeys.sendEmailNodeType)
      .convertToState();

    dispatch({
      type: 'UPDATE',
      payload: { nodes, edges },
    });
  }, [dispatch, state]);
};
